(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NetworkSwitcherGlyph", [], factory);
	else if(typeof exports === 'object')
		exports["NetworkSwitcherGlyph"] = factory();
	else
		root["NetworkSwitcherGlyph"] = factory();
})(this, function() {
return 